import React, { memo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { DataTable, Icon, Modal } from '../../widgets'
import { toDisplayDateTimeString } from '../../../helpers/moment-ex';
import { formatNumber, Unit } from '../../../helpers/unit';
import TareForm from './TareForm';
import { deleteLoad } from '../../../actions/logistics';

const TareHistoryRow = ({ data, index, getLogisticsTareHistory, nonEmptyColumns }) => {
	const unit = Unit.getInstance();
	const [showForm, setShowForm] = useState(false);
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const dispatch = useDispatch();

	const isWebfmLoad = data.hasOwnProperty('meta_data') && data.meta_data.hasOwnProperty('location') && !data.meta_data.location.latitude ? true : false

	const {
		source_equipment_group_name,
		source_operator_name,
		target_equipment_group_name,
		operator_name,
		offload_geo_shape_name,
		offload_geo_storage_location_name,
		load_capacity,
		load_date,
		load_activity_uuid,
		crew_name,
	} = data;

	const hasValue = (value) => value ? value : <span className='text-danger'>Unknown</span>;

	const isNonEmptyColumn = columnName => nonEmptyColumns.includes(columnName);
	const handleDelete = () => dispatch(deleteLoad({ load_activity_uuid }, () => getLogisticsTareHistory()));

	return (
		<>
			<DataTable.Row style={{ backgroundColor: isWebfmLoad ? '#e2ffe9' : null }}>
				<DataTable.Cell>{index}</DataTable.Cell>
				{isNonEmptyColumn('crew_name') && <DataTable.Cell>{hasValue(crew_name)}</DataTable.Cell>}
				{isNonEmptyColumn('source_equipment_group_name') && <DataTable.Cell>{hasValue(source_equipment_group_name)}</DataTable.Cell>}
				{isNonEmptyColumn('source_operator_name') && <DataTable.Cell>{hasValue(source_operator_name)}</DataTable.Cell>}
				{isNonEmptyColumn('target_equipment_group_name') && <DataTable.Cell>{hasValue(target_equipment_group_name)}</DataTable.Cell>}
				{isNonEmptyColumn('operator_name') && <DataTable.Cell>{hasValue(operator_name)}</DataTable.Cell>}
				{isNonEmptyColumn('offload_geo_shape_name') && <DataTable.Cell>{hasValue(offload_geo_shape_name)}</DataTable.Cell>}
				{isNonEmptyColumn('offload_geo_storage_location_name') && <DataTable.Cell>{hasValue(offload_geo_storage_location_name)}</DataTable.Cell>}
				{isNonEmptyColumn('load_capacity') && <DataTable.Cell>{formatNumber(unit.toRoundOfWeight(load_capacity, 2))}</DataTable.Cell>}
				{isNonEmptyColumn('load_date') && <DataTable.Cell>{hasValue(toDisplayDateTimeString(load_date, false, false))}</DataTable.Cell>}

				<DataTable.Cell>
					<div className='tare-action d-flex'>
						<Icon title={"Edit"} className="fa fa-pencil ml-2 cursor-pointer" onClick={() => setShowForm(true)} />
						<Icon title={"Delete"} className="fa fa-trash ml-2 cursor-pointer" onClick={() => setShowDeleteModal(true)} />
					</div>
				</DataTable.Cell>
			</DataTable.Row>

			<TareForm formType='edit' show={showForm} onHide={() => setShowForm(false)} load={data} getLogisticsTareHistory={getLogisticsTareHistory} />

			<Modal.Confirm
				className="modal-bordered"
				show={showDeleteModal}
				onConfirm={handleDelete}
				onHide={() => setShowDeleteModal(false)}
				iconClassName="fa fa-question"
				title={{ content: "Confirmation" }}
				content={`Do you want to delete?`}
			/>
		</>
	)
}

export default memo(TareHistoryRow)